<template>
  <div class="inner-wrapper">
    <div>
      <maintenance-info />
      <bm-privacy />
      <div class="page-line">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <app-header />
      <router-view />
    </div>
    <div>
      <div class="page-line">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <app-footer />
      <scroll-to-top :position="scrollY" />
    </div>
  </div>
</template>

<script>
import AppHeader from '@/eon/components/AppHeader'
import AppFooter from '@/eon/components/AppFooter'
import ScrollToTop from '@/eon/components/ScrollToTop'
import MaintenanceInfo from '@/common/components/maintenanceInfo'

export default {
  components: {
    MaintenanceInfo,
    ScrollToTop,
    AppFooter,
    AppHeader
  },
  data () {
    return {
      scrollY: 0
    }
  },
  methods: {
    handleScroll () {
      this.scrollY = window.scrollY
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style src="./assets/scss/app.scss" lang="scss"></style>
